import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-1 text-sm text-foreground-500"
    >
      <Link to="/" className="hover:text-primary-600 cursor-pointer">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-foreground-300" />
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}